/*
 * SummaryTransfer.jsx
 * Description:
 * Copyright (c) 2021 PredictiveUX
 */
import React from 'react';

import MobileTransferSuccess from './MobileTransferSuccess/MobileTransferSuccess';
import SuccessLastRow from './SuccessLastRow';
import SuccessSecondRow from './SuccessSecondRow';

const SummaryTransfer = ({
  transfer,
  bankAccount,
  destAccount,
  bankAccountLogo,
  escrowAccountLogo,
  tenant,
  disbursement,
}) => (
  <div className="create-account__container-info">
    <>
      <MobileTransferSuccess
        transfer={transfer}
        bankAccount={bankAccount}
        destAccount={destAccount}
        bankAccountLogo={bankAccountLogo}
        escrowAccountLogo={escrowAccountLogo}
        disbursement={disbursement}
        tenant={tenant}
      />
      <div className="d-none d-lg-block">
        <SuccessSecondRow
          transfer={transfer}
          tenant={tenant}
          bankAccount={bankAccount}
          destAccount={destAccount}
          bankAccountLogo={bankAccountLogo}
          escrowAccountLogo={escrowAccountLogo}
          disbursement={disbursement}
        />
        <SuccessLastRow transfer={transfer} hidden={!disbursement} />
      </div>
    </>
  </div>
);

export default SummaryTransfer;
